import React from 'react';

type IterationTabsProps = {
    activeTab: string;
    setActiveTab: (tab: 'matchingConditions' | 'attributeSorting') => void;
};

const IterationTabs: React.FC<IterationTabsProps> = ({ activeTab, setActiveTab }) => {

    const handleTabChange = (tab: 'matchingConditions' | 'attributeSorting') => {
        setActiveTab(tab);
    };

    return (
        <div className="" data-testid="iteration-tabs">
            <div className="tw-flex tw-gap-6 tw-ml-6">
                <button
                    className={`tw-px-1 tw-py-3 tw-font-medium ${activeTab === 'matchingConditions'
                        ? 'tw-border-b-2 tw-border-blue-950 tw-text-blue-950'
                        : 'tw-text-gray-600'
                        }`}
                    onClick={() => handleTabChange('matchingConditions')}
                    data-testid="matching-conditions-tab"
                >
                    Matching Conditions
                </button>
                <button
                    className={`tw-px-1 tw-py-3 tw-font-medium ${activeTab === 'attributeSorting'
                        ? 'tw-border-b-2 tw-border-blue-950 tw-text-blue-950'
                        : 'tw-text-gray-600'
                        }`}
                    onClick={() => handleTabChange('attributeSorting')}
                    data-testid="attributes-sorting-tab"
                >
                    Attributes Sorting
                </button>
            </div>
        </div>
    );
};

export default IterationTabs;